export const NOT_SAVED_ALERT =
	'There may be unsaved changes. Continuing away from this page may result in lost changes. Do you wish to continue?';
